export enum ContentType {
  title = 'title',
  paragraph = 'paragraph',
  simpleCode = 'simpleCode',
  versionedCode = 'versionedCode',
  summary = 'summary',
  heading = 'heading',
  image = 'image',
  simpleTable = 'simpleTable',
  unorderedList = 'unorderedList',
  markdown = 'markdown'
}

export enum PostType {
  series = 'series',
  normal = 'normal',
}
